export default {
    data : [
        {
            id:'data_kategori', type:'info', label:'Master Kategori', hidden: 'no',
            child: [
                {id:'id', content_text: 'text', type:'text', label:'Id', hidden: 'yes'},
                {id:'klasifikasi_id', content_text: 'text', type:'text_id', label:'Id', hidden: 'yes'},
                {id:'nama', content_text: 'text', type:'text', label:'Nama', hidden: 'no'},
            ]

        }
    ]
}